<template>
  <div class="keyboard-row">
    <KeyButton @click="e => $emit('click', e)" @layout="e => $emit('layout', e)" :key="idx" :key_label="key" :control_states="control_states" v-for="(key, idx) in row" />
  </div>
</template>

<script>
import KeyButton from './KeyButton.vue'
export default {
  props:{
    row: Array,
    control_states: Object
  },
  components:{
    KeyButton
  }
}
</script>

<style scoped>
.keyboard-row {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>